import InsertInvitationSharpIcon from "@mui/icons-material/InsertInvitationSharp";
import MailOutlineSharpIcon from "@mui/icons-material/MailOutlineSharp";
import { ListItem, ListItemButton, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import dayjs from "dayjs";
import { useContext, useMemo } from "react";
import EventNoteButton from "./EventNoteButton";
import { UserContext } from "components/context/UserProvider";

const ActionListItem = ({ object, primaryClick }) => {
  const theme = useTheme();
  const { user } = useContext(UserContext);

  const nameFrom = useMemo(() => {
    const fromLink = object.action_links.filter(
      (action_link) => action_link.link_type === "from",
    )[0];
    return fromLink?.name || fromLink?.email_address;
  }, [object]);

  const sameUser = useMemo(() => {
    return object.account.user.id == user.id;
  }, [object, user]);

  return (
    <ListItem
      secondaryAction={
        object?.action_type === "event" ? (
          <EventNoteButton event={object} />
        ) : (
          <>&nbsp;</>
        )
      }
    >
      <ListItemButton
        onClick={() => {
          primaryClick(object);
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={1}
        >
          {object?.action_type == "event" ? (
            <InsertInvitationSharpIcon
              width={20}
              sx={{
                flexShrink: 0,
                scale: "0.8",
                color: sameUser ? theme.palette.success.dark : undefined,
              }}
            />
          ) : (
            <MailOutlineSharpIcon
              width={20}
              sx={{
                flexShrink: 0,
                scale: "0.8",
                color: sameUser ? theme.palette.success.dark : undefined,
              }}
            />
          )}
          <Typography
            variant="body2"
            width={80}
            textAlign={"center"}
            sx={{ flexShrink: 0 }}
          >
            {dayjs(object.date).format("DD/MM/YYYY")}
          </Typography>
          <Typography flexGrow={1} noWrap>
            {object.title}
          </Typography>
          <Typography
            variant="body2"
            noWrap
            width={"fit-content"}
            sx={{ flexShrink: 0 }}
            textAlign={"end"}
          >
            {nameFrom}
          </Typography>
        </Stack>
      </ListItemButton>
    </ListItem>
  );
};

export default ActionListItem;
